import _ from 'lodash'
import DrillingRecord from './DrillingRecord'
import AppOrderRecord from './AppOrderRecord'
import LeaseRecord from './LeaseRecord'
import PluggingRecord from './PluggingRecord'
import RespondentRecord from './RespondentRecord'
import CertOfCompRecord from './CertOfCompRecord'
import UnitizationRecord from './UnitizationRecord'
import ProductionRecord from './ProductionRecord'

class RecordMapService {
  constructor(config) {
    this.recordTypeMap = {
      'Transfer of Operator': this.drilling,
      'Completion': this.drilling,
      'Permit to Drill': this.drilling,
      'Commingle': this.drilling,
      'Pooling': this.appOrder,
      'Increased Density': this.appOrder,
      'Location Exception': this.appOrder,
      'Spacing': this.appOrder,
      'Lease': this.leasing,
      'Plugging': this.plugging,
      'Respondent': this.respondent,
      'Cert of Comp & Trans Authority': this.certOfComp,
      'Production': this.production,
      'Unitization': this.unitization
    }
    this.config = config
  }

  matchRecord(record, callback) {
    if (_.isUndefined(this.recordTypeMap[record.type_of_document])) {
      throw `Record ${record.type_of_document} is an invalid document type`
    }
    return this.recordTypeMap[record.type_of_document](record, callback, this.config)
  }

  plugging(data, callback, config) {
    const record = new PluggingRecord(data, config)
    if (callback) callback(record)

    return record
  }

  leasing(data, callback, config) {
    const record = new LeaseRecord(data, config)
    if (callback) callback(record)

    return record
  }

  drilling(data, callback, config) {
    const record = new DrillingRecord(data, config)
    if (callback) callback(record)

    return record
  }

  appOrder(data, callback, config) {
    const record = new AppOrderRecord(data, config)
    if (callback) callback(record)

    return record
  }

  respondent(data, callback) {
    const record = new RespondentRecord(data)
    if (callback) callback(record)

    return record
  }

  certOfComp(data, callback) {
    const record = new CertOfCompRecord(data)
    if (callback) callback(record)

    return record
  }

  unitization(data, callback, config) {
    const record = new UnitizationRecord(data, config)
    if (callback) callback(record)

    return record
  }

  production(data, callback) {
    console.log("Creating production record")
    const record = new ProductionRecord(data)
    if (callback) callback(record)

    return record
  }
}

RecordMapService.$inject = ['config']

export default RecordMapService
